export const isLab = () => {
  return process.env.REACT_APP_ENVIRONMENT === 'LAB'
}
